var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkthroughTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_90704)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    transform: "translate(0.559326 0.913086)",
    fill: "#FFF308"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.55933,
    y: 1.91309,
    width: 32,
    height: 32,
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1128_90704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2445 18.2725C13.9772 18.2725 11.3286 20.9303 11.3286 24.209H23.1604C23.1604 20.9303 20.5118 18.2725 17.2445 18.2725Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3436 18.2724C25.9772 18.2724 27.3015 16.9435 27.3015 15.3042C27.3015 13.6649 25.9772 12.3359 24.3436 12.3359C22.7099 12.3359 21.3856 13.6649 21.3856 15.3042C21.3856 16.9435 22.7099 18.2724 24.3436 18.2724Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3436 18.8008C23.5511 18.8008 22.8055 18.9974 22.1486 19.3425C23.3823 20.5941 24.1464 22.3145 24.1464 24.2092H29.0295C29.0591 23.994 29.0763 23.7738 29.0763 23.55C29.0763 20.9268 26.9577 18.8008 24.3436 18.8008Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1454 18.8008C7.53135 18.8008 5.41272 20.9268 5.41272 23.55C5.41272 23.7738 5.42874 23.994 5.45955 24.2092H10.3426C10.3426 22.3132 11.1055 20.5941 12.3405 19.3425C11.6848 18.9974 10.9379 18.8008 10.1454 18.8008Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2445 17.2833C19.1504 17.2833 20.6955 15.7329 20.6955 13.8204C20.6955 11.9078 19.1504 10.3574 17.2445 10.3574C15.3386 10.3574 13.7936 11.9078 13.7936 13.8204C13.7936 15.7329 15.3386 17.2833 17.2445 17.2833Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1454 18.2724C11.7791 18.2724 13.1034 16.9435 13.1034 15.3042C13.1034 13.6649 11.7791 12.3359 10.1454 12.3359C8.51182 12.3359 7.1875 13.6649 7.1875 15.3042C7.1875 16.9435 8.51182 18.2724 10.1454 18.2724Z",
    fill: "#151515"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_90704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.559326 0.913086)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1128_90704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6636,
    height: 13.8519,
    fill: "white",
    transform: "translate(5.41272 10.3574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthroughTeams);
export default __webpack_public_path__ + "static/media/walkthrough-teams.f91241bd7b8d1a5e98eff11a9f236ab7.svg";
export { ForwardRef as ReactComponent };